import httpClient from '@/api/http-client';

const endpoint = 'api/metatags';

const metatagService = {
  getMetaTags: (params) => httpClient.get(endpoint, { params }),

  create: (metatag) => httpClient.post(`${endpoint}`, metatag),
};

export default metatagService;
